import {SupportedRequirement} from '@yandex-taxi/js-integration-api'

export type Props = {
  requirement: SupportedRequirement
  tariff: string
}

export enum RequirementName {
  DOOR_2_DOOR = 'door_to_door',
}
